module.exports = __webpack_public_path__ + "static/media/soapbox.9aebf861.png";